import { render, staticRenderFns } from "./AttributesEdit.vue?vue&type=template&id=2d23603b&scoped=true"
import script from "./AttributesEdit.vue?vue&type=script&lang=js"
export * from "./AttributesEdit.vue?vue&type=script&lang=js"
import style0 from "./AttributesEdit.vue?vue&type=style&index=0&id=2d23603b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23603b",
  null
  
)

export default component.exports